import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { JobTitles, CreateJobTitle, UpdateJobTitle } from "./pages";

export const JobTitlesRouter = [
  <Route
    path="/job-titles"
    element={
      <ProtectedRoute roles={["Any"]}>
        <JobTitles />
      </ProtectedRoute>
    }
  />,

  <Route path="/job-title">
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateJobTitle />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateJobTitle />
        </ProtectedRoute>
      }
    />
  </Route>,
];
